import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import React, { useEffect, useState } from 'react';
import XMLViewer from 'react-xml-viewer';
import { useTranslation } from 'react-i18next';

interface XMLModalProps {
  toggle: () => void;
  isOpen: boolean;
  xmlData: string;
  onClose: () => void;
}

const XMLModal: React.FC<XMLModalProps> = (props) => {
  const [ xml, setXml ] = useState<boolean>(false);
  const [ data, setData ] = useState<string>('');
  const { t } = useTranslation();

  useEffect(() => {
    setXml(false);
    try {
      const jsonString = JSON.parse(props.xmlData);
      setData(JSON.stringify(jsonString, null, 2));
    } catch (e) {
      if (props.xmlData.startsWith('<?xml')) {
        setXml(true);
      }
      setData(props.xmlData);
    }
  }, [ props.xmlData ]);

  return (
    <Modal style={{ minWidth: '1060px' }} isOpen={props.isOpen} toggle={props.toggle} autoFocus={false}>
      <ModalBody>
        <div className="scrolling-modal-div-large">
          {!xml ?
            <pre>{data}</pre> :
            <XMLViewer xml={data}/>
          }
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={props.onClose}>{t('b.close').toUpperCase()}</Button>
      </ModalFooter>
    </Modal>
  );
};

export default XMLModal;
